<template>
  <div class="sidebar"
       :data-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo" style="padding: 20px 0;cursor: pointer;" @click="goHome">
      <el-row :gutter="10">
          <div class="simple-text logo-mini logo-img text-center">
            <!-- <img :src="logo" style="width: 34px"> -->
            <img :src="require('@/assets/images/rms-mnu-logo.png')" style="width:190px;"/>
          </div>
      </el-row>
    </div>
    <!-- <div class="sidebar-wrapper" ref="sidebarScrollArea"> -->
    <div class="sidebar-wrapper" >
      <!-- <button @click.prevent="syncTest()">vsynctest</button> -->
      <user-menu @activate="activeType = 'user'" :active-type="activeType"></user-menu>
      <slot>

      </slot>
      <aw-smooth-scrollbar :scroll-x="false" :scroll-y="true">
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in $store.state.account.myMenus"
                        :key="link.name + index"
                        :link="link"
                        :active-type="activeType"
                        @activate="activeType = 'mnu'">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink"
                          :active-type="activeType"
                          @activate="activeType = 'mnu'"
                          >
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
      </aw-smooth-scrollbar>

    </div>
    <div class="toggle-indicator" @click="toggleSideBar">
      <a href="javascript:;" class="toggle-btn">
        <i v-if="!isShowMenu" class="fa fa-caret-right"></i>
        <i v-if="isShowMenu"  class="fa fa-caret-left"></i>
      </a>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'
  import SmoothScrollbar from 'vue-smooth-scrollbar'
  import AwSmoothScrollbar from '../scroll-bar/AwSmoothScrollbar.vue'
  import {Row, Col} from 'element-ui'
  import syncHeightTestModal from '@/components/Pages/Views/Common/syncHeightTestModal.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'

  Vue.use(Row)
  Vue.use(Col)

  export default {
    components: {
      AwSmoothScrollbar,
      UserMenu
    },
    data() {
      return {
        activeType: 'mnu',
        isShowMenu: true
      }
    },
    props: {
      title: {
        type: String,
        default: 'Ewide',
        description: 'Ewide'
      },
      backgroundColor: {
        type: String,
        default: 'white',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar background color (white|brown|black)'
      },
      activeColor: {
        type: String,
        default: 'danger',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar active text color (primary|info|success|warning|danger)'
      },
      logo: {
        type: String,
        default: '/static/img/background/logo.png',
        description: 'Sidebar Logo'
      },
      sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      }
    },
    watch: {
      isUserMnuClick( clicked ) {
        
      }
    },
    methods: {
      async initScrollBarAsync () {
        let isWindows = navigator.platform.startsWith('Win');
        if(!isWindows) {
          return;
        }
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      },
      goHome () {
        Vue.router.push({
          name: 'Home',
        });
      },
      syncTest() {
        this.$modal.show(
          () => import('@/components/Pages/Views/Common/syncHeightTestModal.vue'), 
          { },
          { width:'600px', /*height: '90%',*/ escToClose: false },
          { }
        )

      },
      toggleSideBar() {
        this.$sidebar.toggleMinimize();
        this.isShowMenu = !this.isShowMenu;
        localStorage.setItem('showMenu', this.isShowMenu ? 'Y' : 'N')
      }

    },
    created: function () {
        // 메뉴 리스트
        this.$store.dispatch('account/getMyMenus');
    },
    mounted () {
      this.initScrollBarAsync()
      if((localStorage.getItem('showMenu') || 'Y') === 'N') {
        this.toggleSideBar();
      }

    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style >
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
  .sidebar .nav { margin-bottom: 20px; overflow-x: hidden;}
  .sidebar-mini-icon {
    text-transform: uppercase;
    width: 34px;
    margin-right: 10px;
    margin-left: 0;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    position: relative;
    float: left;
    z-index: 1;
    display: inherit;
    color: hsla(0,0%,100%,.5);
  }
  .sidebar .nav .sidebar-mini-icon > i { font-size: 15px; }


  .sidebar .nav li > a .sidebar-normal { line-height: 20px;  }

  .wrapper .sidebar .aw-smooth-scrollbar { z-index: 4; overflow-y: visible; height: calc(100vh - 138px)}
  .wrapper .sidebar .sidebar-wrapper {overflow-y:visible; height: auto;}

  .sidebar[data-color="white"] .nav li a { color: #dcdcf0 !important; font-weight: 600; font-size:13px;} 

  .sidebar[data-color="white"] .nav li a i, .sidebar[data-color="white"] .nav li a[data-toggle="collapse"] i {
    color: #dcdcf0 !important;
  }
  .wrapper .sidebar[data-color="white"] .user .info a span { color: #dcdcf0 !important; }
  .wrapper .sidebar .logo:after, .sidebar .user:after { display: none;}
  .wrapper .sidebar .user { padding-bottom: 0px;}
  .wrapper .sidebar .nav { margin-top: 0; }
  .wrapper .logo-text {display: inline-block;
    background: white;
    border-radius: 4px;
    padding: 0 10px;
    font-size: 14px;
    line-height: 24px;
    width: 100px;
    text-align: center;
    color: #071e3f;
    font-weight: 800;}

 
</style>
<style scoped>
  .sidebar ::v-deep .caret {
    border-top: 6px dashed;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    right: 23px !important;
  } 
  .sidebar .user ::v-deep .caret {
    right: 18px !important;
  }
  .sidebar ::v-deep .nav li { 
    padding: 0;
    position: relative;
  }
  .sidebar ::v-deep .scroll-content > .nav > li,
  .sidebar ::v-deep .user li { 
    margin: 6px 12px;
  }


  .sidebar ::v-deep .nav li a { 
    padding: 7px 0 7px 25px;
    margin: 0px;
    position: relative;
    display: block;
    font-weight: 800;
    font-size: 15px;  
    opacity: 1 !important;  
  }

  .sidebar ::v-deep .scroll-content > .nav li > div > .nav li a { 
    padding: 5px 0 5px 35px;
    font-weight: 600;
    font-size: 14px;    
    opacity: .8 !important;
  }


  .sidebar ::v-deep .nav li.active { 
    background-color: #2e3c6b;
    border-radius: 4px;
  }

  .sidebar ::v-deep .nav > li > div > ul > li.active > a.active,
  .sidebar ::v-deep .nav li a[aria-current] { 
    background-color: #415091 !important;
    border-radius: 4px;
  }
  .sidebar .sidebar-wrapper ::v-deep .nav > li > div > ul > li.active > a.active:after,
  .sidebar ::v-deep .nav li a[aria-current]:after { 
    content: '';
    position: absolute !important;
    width: 4px !important;
    height: 100%;
    background-color: white;
    left: 0;
    top: 0 !important;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    display: block !important;
    border: none !important;
  }
  .toggle-indicator {
    height: 100vh;
    width: 20px;
    background-color: #071e3f;
    border-left: 1px solid #2c3a63;
    right: -20px;
    top: 0;
    position: absolute;
    cursor: pointer;
    z-index: 10000;
  }

  .toggle-btn {
    position: absolute;
    top: 50%;
    color: white;
    font-size: 18px;
    left: 5px;
  }

</style>
